import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import parse from "date-fns/parse";

/**
 *
 * @param value ISODateTimeString
 * @returns Date
 */

const checkYYYYMMDDWithDash = new RegExp(
  /(((2\d\d\d|19\d\d|9999))-(0[0-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))/
);

export function formatDatetime(value: string) {
  return format(parseISO(value), "dd/MM/yyyy HH:mm:ss");
}

export function formatDate(value: string) {
  return parse(value, "yyyyMMdd", new Date());
}

export function formatYYYYMMDDWithDashToDDMMYYYY(value: string) {
  return checkYYYYMMDDWithDash.test(value)
    ? format(parse(value, "yyyy-MM-dd", new Date()), "dd/MM/yyyy")
    : value;
}

export function tryFormatDatetime(value: string) {
  try {
    return formatDatetime(value);
  } catch {
    return "";
  }
}
